import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { WebsiteImagePanelContent } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { AdsStudioAddAssetPanel } from './add-asset-panel';
import { useSourceImages } from './hooks/use-source-images';

export const WebsiteImagePanel = (props) => {
  const {
    i18n, aid, cid, oDataConfig, dataService, logger, notificationApi, navigation, open, perfMarker,
  } = props;
  const {
    setSelectedImages, onWebsiteClickSelect, showBlocker, selectedImages,
  } = useSourceImages({
    dataService, logger, navigation, perfMarker,
  });

  const dismiss = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  return (
    <AdsStudioAddAssetPanel
      i18n={i18n}
      aid={aid}
      dismiss={dismiss}
      isOpen={open}
      showBlocker={showBlocker}
      selectedAsset={selectedImages}
      headerText={props.i18n.getString(_TL_('Add assets from your website '))}
      logger={logger}
      notificationApi={notificationApi}
      onClickSelect={onWebsiteClickSelect}
    >
      <WebsiteImagePanelContent i18n={props.i18n} aid={aid} cid={cid} oDataConfig={oDataConfig} setSelectedImages={setSelectedImages} />
    </AdsStudioAddAssetPanel>
  );
};

WebsiteImagePanel.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({ gotoImagesPage: PropTypes.func }).isRequired,
  dataService: PropTypes.shape({
    uploadImage: PropTypes.func,
    uploadStockImage: PropTypes.func,
    uploadImageByUrl: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
  open: PropTypes.bool.isRequired,
};
